import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloudQueueIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cloud_queue"}/>
}
